export { BaselineComponent } from './baseline.component';
export { remediate as Remediate } from './remediate';
export const href =
    'https://learn.microsoft.com/en-us/entra/identity/conditional-access/concept-conditional-access-policies';
